import { format, isValid, parse } from 'date-fns'

import { HUMAN_DATE_FORMAT, HUMAN_MONTH_DATE_FORMAT } from '@Constants/date'
import { HUMAN_DATE_TIME_FORMAT, HUMAN_MONTH_DATE_TIME_FORMAT } from '@Constants/dateTime'
import { type DateFormat } from '@Types/date'
import { type DateTimeFormat } from '@Types/dateTime'

const dateMaskPatterns = {
  [HUMAN_MONTH_DATE_FORMAT]: `\`m/\`Y`,
  [HUMAN_DATE_FORMAT]: `\`d/\`m/\`Y`,
}

const dateTimeMaskPatterns = {
  [HUMAN_DATE_TIME_FORMAT]: `\`d/\`m/\`Y \`H:\`M`,
  [HUMAN_MONTH_DATE_TIME_FORMAT]: `\`m/\`Y \`H:\`M`,
}

export const getDateMaskPatternByDateFormat = (dateFormat: DateFormat): string => dateMaskPatterns[dateFormat]

export const getDateTimeMaskPatternByDateFormat = (dateFormat: DateTimeFormat): string =>
  dateTimeMaskPatterns[dateFormat]

export const formatDateInput = (date: Date, formatString: string): string => {
  if (isValid(date)) {
    return format(date, formatString)
  }

  return '' // Retour d'une chaîne vide importante pour ne pas provoquer d'erreur côté iMask
}

export const parseDateInput = (str: string, formatString: string): Date => parse(str, formatString, new Date())
